import React, { useEffect, useState } from 'react';
import { useAuthentication } from '@johnlewispartnership/wtr-website-authentication/dist/context';
import { TextLink } from '@johnlewispartnership/wtr-ingredients/dist/ingredients/TextLink';
import { useShoppingContext } from 'contexts/ShoppingContext';
import { loginPagePath } from 'utils/login-page-path';
import graphQLService from 'services/graphql';
import { getFeatureFlags } from 'utils/featureFlags';
import { ShoppingSummary } from './ShoppingSummary';
import styles from './ShoppingSummaryContainer.module.scss';

const ShoppingSummaryContainer = () => {
  const { state: authState } = useAuthentication();
  const { shoppingContext } = useShoppingContext();
  const { identity_enableOAuth2Web: OAuth2Enabled } = getFeatureFlags();

  // TODO - Move shouldRenderLoggedInVersion to a shared location to avoid repetition
  const shouldRenderLoggedInVersion =
    (authState.hasTokenSession && !authState.initialised) ||
    (authState.initialised && authState.isLoggedIn);

  const [trolleyState, setTrolleyState] = useState({
    loading: authState.hasTokenSession && !authState.initialised && OAuth2Enabled,
    totalEstimatedCost: 0,
    totalNumberOfItems: 0,
  });

  const SignInOrTrolley = shouldRenderLoggedInVersion ? (
    <ShoppingSummary
      loadingStatus={trolleyState.loading}
      totalEstimatedCost={trolleyState.totalEstimatedCost}
      totalNumberOfItems={trolleyState.totalNumberOfItems}
    />
  ) : (
    <TextLink data-testid="mobileHeaderSigninLink" href={loginPagePath()} underline="never">
      Sign in
    </TextLink>
  );

  useEffect(() => {
    const doEffect = async () => {
      setTrolleyState({
        loading: true,
        totalEstimatedCost: 0,
        totalNumberOfItems: 0,
      });

      // bang added to authstate token due to compiler not registering that it will always be defined via if condition
      const trolley = await graphQLService.getTrolley(
        shoppingContext.customerOrderId,
        authState.token!.authHeader,
      );

      // TODO - Handle errors after WPIP-60665
      if (!trolley.error) {
        setTrolleyState({
          loading: false,
          totalEstimatedCost: trolley.totalEstimatedCost,
          totalNumberOfItems: trolley.totalNumberOfItems,
        });
      } else {
        setTrolleyState({
          loading: false,
          totalEstimatedCost: 0,
          totalNumberOfItems: 0,
        });
      }
    };

    if (shoppingContext.customerOrderId && authState.token && OAuth2Enabled) {
      doEffect();
    }
  }, [authState.token, OAuth2Enabled, shoppingContext.customerOrderId]);

  return (
    <>
      <div className={styles.trolley}>
        <ShoppingSummary
          loadingStatus={trolleyState.loading}
          totalEstimatedCost={trolleyState.totalEstimatedCost}
          totalNumberOfItems={trolleyState.totalNumberOfItems}
        />
      </div>
      <div className={styles.signInOrTrolley}>{SignInOrTrolley}</div>
    </>
  );
};

export default ShoppingSummaryContainer;
